import { supabase } from './supabase/supabase-config';

// Camada fina sobre supabase.auth.mfa, so para dar nomes claros e centralizar o
// tratamento de erro. MFA por TOTP (app autenticador: Google Authenticator,
// Authy, etc). Aplicado apenas ao admin — o cliente comum nunca passa por isto.

// Nivel de garantia da sessao atual:
//   currentLevel 'aal2'                    -> ja passou o segundo fator
//   nextLevel 'aal2' e currentLevel 'aal1' -> tem MFA, falta desafiar nesta sessao
//   nextLevel 'aal1'                        -> nao tem MFA cadastrado
export async function nivelGarantia() {
  const { data, error } = await supabase.auth.mfa.getAuthenticatorAssuranceLevel();
  if (error) throw error;
  return data; // { currentLevel, nextLevel, ... }
}

export async function listarFatores() {
  const { data, error } = await supabase.auth.mfa.listFactors();
  if (error) throw error;
  return data; // { totp: [...], all: [...] }
}

// Primeiro fator TOTP ja verificado, se houver.
export async function fatorTotpVerificado() {
  const { totp } = await listarFatores();
  return (totp ?? []).find((f) => f.status === 'verified') ?? null;
}

// Inicia o cadastro: devolve o factorId e o QR (data URI) para escanear no app.
export async function iniciarCadastro() {
  const { data, error } = await supabase.auth.mfa.enroll({
    factorType: 'totp',
    friendlyName: 'RNPlugin Admin',
  });
  if (error) throw error;
  return { factorId: data.id, qr: data.totp.qr_code, secret: data.totp.secret };
}

// Confirma um codigo de 6 digitos contra um fator (usado tanto para finalizar o
// cadastro quanto para o desafio de login).
export async function confirmarCodigo(factorId, codigo) {
  const { data: ch, error: e1 } = await supabase.auth.mfa.challenge({ factorId });
  if (e1) throw e1;
  const { error: e2 } = await supabase.auth.mfa.verify({
    factorId,
    challengeId: ch.id,
    code: codigo,
  });
  if (e2) throw e2;
}

export async function removerFator(factorId) {
  const { error } = await supabase.auth.mfa.unenroll({ factorId });
  if (error) throw error;
}
